import cd from "debug";
import { loader } from "@guolao/vue-monaco-editor";
import { getKsStorage } from "./common/utils/ksStorage";

const debug = cd("monaco-editor");

function getMonacoUrl(file?: string) {
  // 使用 0.54.0 版本修复 @monaco-editor/loader 更新导致 0.52.2 加载不出来的问题
  // FIXME: 0.54.0 以后的版本将抛弃 amd 打包的方式，因此后期还是得使用 esm 打包的方式
  // see {@link https://github.com/microsoft/monaco-editor/blob/HEAD/CHANGELOG.md#0530}
  const version = "0.54.0";
  const prefix = __DEV__ ? `/monaco-editor@${version}/dev` : `/monaco-editor@${version}/min`;
  const p = (file || "").replace(/^\/?/, "/");
  // 必须使用完整路径，否则会导致 worker 脚本加载失败
  const o = globalThis.origin;
  return `${o}${prefix}${p}`;
}

export async function setupMonacoEditor() {
  const langType = getKsStorage().getLangType();

  const vs = getMonacoUrl("vs");
  debug("monaco-editor url", vs);

  loader.config({
    paths: {
      vs,
    },
    // 使用本地 monaco 编辑器时，语言配置不生效，monaco-editor esm 格式不支持国际化
    "vs/nls": {
      availableLanguages: {
        "*": langType === "en" ? "en-us" : "zh-cn",
      },
    },
  });
}

// TODO: 测试中，AMD 格式如何自定义 language server
// self.MonacoEnvironment = {
//   getWorkerUrl: (moduleId: string, label: string) => {
//     // debugger;
//     // if (label === "json") {
//     //   return getMonacoUrl("/language/json/json.worker.js");
//     // }
//     // if (label === "css" || label === "scss" || label === "less") {
//     //   return getMonacoUrl("/language/css/css.worker.js");
//     // }
//     // if (label === "html" || label === "handlebars" || label === "razor") {
//     //   return getMonacoUrl("/language/html/html.worker.js");
//     // }
//     // if (label === "typescript" || label === "javascript") {
//     //   return getMonacoUrl("/language/typescript/ts.worker.js");
//     // }
//     if (label === "yaml") {
//       // TODO:
//       // return getMonacoUrl('');
//     }
//     // console.log("require", require);
//     const workerBaseUrl = new URL(getMonacoUrl(), globalThis.origin).toString();
//     const workerScriptUrl = new URL(
//       getMonacoUrl(`vs/base/worker/workerMain.js#${label}`),
//       globalThis.origin,
//     ).toString();
//     function getNLSMessages() {
//       // console.log("getNLSMessages in worker", (globalThis as any)._VSCODE_NLS_MESSAGES);
//       return (globalThis as any)._VSCODE_NLS_MESSAGES;
//     }
//     function getNLSLanguage() {
//       // console.log("getNLSLanguage in worker", (globalThis as any)._VSCODE_NLS_LANGUAGE);
//       return (globalThis as any)._VSCODE_NLS_LANGUAGE;
//     }
//     const s = [
//       `/*${label}*/`,
//       `globalThis.MonacoEnvironment = { baseUrl: '${workerBaseUrl}' };`,
//       `globalThis._VSCODE_NLS_MESSAGES = ${JSON.stringify(getNLSMessages())};`,

//       `globalThis._VSCODE_NLS_LANGUAGE = ${JSON.stringify(getNLSLanguage())};`,

//       `globalThis._VSCODE_FILE_ROOT = '${(globalThis as any)._VSCODE_FILE_ROOT}';`,

//       `const ttPolicy = globalThis.trustedTypes?.createPolicy('defaultWorkerFactory', { createScriptURL: value => value });`,
//       `globalThis.workerttPolicy = ttPolicy;`,
//       `importScripts('${workerScriptUrl}');`,
//       `/*${label}*/`,
//     ].join("");
//     const blob = new Blob([s], { type: "application/javascript" });
//     return URL.createObjectURL(blob);
//     // return getMonacoUrl(`/base/worker/workerMain.js#${label}`);
//     // return getMonacoUrl("/editor/editor.worker.js");
//   },
// };
